import { Button, Image, Popover, Row, Space, Splitter, Typography } from 'antd';
import { FC, useEffect, useState } from 'react';
import { ReviewDocumentDocumentInfo } from './review-documents-helpers';
import { useMaintenanceMessage } from '../maintenance-message';

const handleKeyDown = (event: KeyboardEvent, callback: () => void) => {
  if (event.key === 'Escape') {
    callback();
  }
};
interface ReviewDocumentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  documentInfos: ReviewDocumentDocumentInfo;
}

export const ReviewDocumentsModal: FC<ReviewDocumentsModalProps> = (props) => {
  const { isImpending } = useMaintenanceMessage();

  const [activeButtonLeft, setActiveButtonLeft] = useState<string | null>(null);
  const [activeButtonRight, setActiveButtonRight] = useState<string | null>(null);

  const [currentRightFileUrl, setCurrentRightFileUrl] = useState<string | undefined>(undefined);
  const [currentLeftFileURL, setCurrentLeftFileURL] = useState<string | undefined>(undefined);

  const handleButtonClick = (button: string, panel: string) => {
    if (panel === 'left') {
      setActiveButtonLeft(button);
      setCurrentLeftFileURL(props.documentInfos[button]?.url);
    } else {
      setActiveButtonRight(button);
      setCurrentRightFileUrl(props.documentInfos[button]?.url);
    }
  };

  // press Esc to close the modal
  useEffect(() => {
    window.addEventListener('keydown', (event) => handleKeyDown(event, closePreview));
    return () => {
      window.removeEventListener('keydown', (event) => handleKeyDown(event, closePreview));
    };
  }, []);

  const closePreview = () => {
    props.onClose();
    setCurrentLeftFileURL(undefined);
    setCurrentRightFileUrl(undefined);
  };

  useEffect(() => {
    if (props.isOpen) {
      setCurrentRightFileUrl(props.documentInfos[activeButtonRight ?? '']?.url);
      setCurrentLeftFileURL(props.documentInfos[activeButtonLeft ?? '']?.url);
    }
  }, [props.isOpen]);

  const getSidePanel = (docUrl: string, filename: string, docTitle: string, fileType: string) => {
    if (filename) {
      return (
        <div
          style={{
            textAlign: 'center',
            height: '80vh',
            overflow: 'auto',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          {docUrl ? (
            <>
              <Row justify={'center'}>
                <Typography.Title level={3} style={{ color: 'white' }}>
                  {docTitle}
                </Typography.Title>
              </Row>
              {fileType === 'application/pdf' ? (
                <Row style={{ height: '100%' }}>
                  <embed src={docUrl ?? ''} width="100%" height="100%" style={{ border: 'none' }} title={`${filename}`} />
                </Row>
              ) : docUrl ? (
                <Image preview={false} style={{ objectFit: 'contain', overflow: 'scroll' }} width={'100%'} height={'100%'} src={docUrl} alt={filename ?? ''} />
              ) : (
                <p>Select a document to review</p>
              )}
            </>
          ) : (
            <Row style={{ width: '100%', height: '100%', alignItems: 'center' }} justify={'center'}>
              <Typography.Title level={4} style={{ color: 'white' }}>
                No file found.
              </Typography.Title>
            </Row>
          )}
        </div>
      );
    } else {
      return (
        <Row style={{ width: '100%', height: '100%', alignItems: 'center' }} justify={'center'}>
          <Typography.Title level={1} style={{ color: 'white' }}>
            Select a document to review
          </Typography.Title>
        </Row>
      );
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      {props.isOpen && (
        <div
          style={{
            position: 'fixed',
            top: isImpending ? 143 : 60,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            zIndex: 1000,
            color: '#fff',
            padding: '10px'
          }}
        >
          <Button
            onClick={closePreview}
            style={{
              position: 'absolute',
              top: '5px',
              right: '5px',
              backgroundColor: 'transparent',
              color: '#fff',
              zIndex: 1001,
              fontWeight: 'bold',
              border: 'none'
            }}
          >
            X
          </Button>
          <Row justify={'center'} style={{ marginBottom: '10px', marginTop: '30px' }}>
            <Space size={'large'} style={{ overflowX: 'scroll', scrollbarWidth: 'none' }}>
              {Object.keys(props.documentInfos).map((doc) => (
                <Popover
                  content={
                    <Space>
                      <Button onClick={() => handleButtonClick(doc, 'left')}>Left</Button>
                      <Button onClick={() => handleButtonClick(doc, 'right')}>Right</Button>
                    </Space>
                  }
                >
                  <Button style={{ height: '40px' }} key={doc} type={activeButtonLeft === doc || activeButtonRight === doc ? 'primary' : 'default'}>
                    {props.documentInfos[doc].title}
                  </Button>
                </Popover>
              ))}
            </Space>
          </Row>

          <Splitter style={{ height: '100%', color: 'white' }}>
            <Splitter.Panel defaultSize="50%" min="20%" max="70%" style={{ border: '1px solid white' }}>
              {getSidePanel(
                currentLeftFileURL ?? '',
                activeButtonLeft ?? '',
                props.documentInfos[activeButtonLeft ?? '']?.title,
                props.documentInfos[activeButtonLeft ?? '']?.fileType ?? ''
              )}
            </Splitter.Panel>
            <Splitter.Panel style={{ border: '1px solid white' }}>
              {getSidePanel(
                currentRightFileUrl ?? '',
                activeButtonRight ?? '',
                props.documentInfos[activeButtonRight ?? '']?.title,
                props.documentInfos[activeButtonRight ?? '']?.fileType ?? ''
              )}
            </Splitter.Panel>
          </Splitter>
        </div>
      )}
    </div>
  );
};
